import React from 'react';

const Footer = () => {
  return (
    <div style={{ textAlign: 'center', marginBottom: 10 }}>
      Made with ❤ by{' '}
      <a href="https://ruvaim.me/" target="_blank" rel="noopener noreferrer">
        Ruvaim Kash
      </a>
    </div>
  );
};

export default Footer;
